import React, { memo } from 'react'
import { RemoveWarehouseModalProps } from './types'
import { Modal } from '../../../modal'
import { Col, Row } from 'react-grid-system'
import Button from '../../../button/button'

import * as styles from './removeWarehouseModal.module.scss'

const RemoveWarehouseModal = ({
   isOpen,
   setIsOpen,
   handleTransfer,
   handleAdjust,
   selectedWarehouseId,
}: RemoveWarehouseModalProps) => (
   <Modal
      title="Remove or Transfer Inventory First"
      isModalVisible={isOpen}
      closeModal={() => setIsOpen(false)}
   >
      <div className={styles.content}>
         <p>
            The Home Warehouse Location you're trying to remove still has
            inventory. Please set inventory levels to zero or transfer to
            another location before removing.
         </p>
         <Row>
            <Col xs={12} sm={6}>
               <Button
                  type="button"
                  minWidth="100%"
                  variant="success"
                  onClick={() => handleAdjust(selectedWarehouseId)}
               >
                  Adjust
               </Button>
            </Col>
            <Col xs={12} sm={6}>
               <Button
                  type="button"
                  minWidth="100%"
                  variant="tertiary"
                  onClick={() => handleTransfer(selectedWarehouseId)}
               >
                  Transfer
               </Button>
            </Col>
         </Row>
      </div>
   </Modal>
)

export default memo(RemoveWarehouseModal)
